import { render, staticRenderFns } from "./OfferPane.vue?vue&type=template&id=54dec27f&scoped=true"
import script from "./OfferPane.vue?vue&type=script&setup=true&lang=ts"
export * from "./OfferPane.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54dec27f",
  null
  
)

export default component.exports